import React, {Component, ReactElement} from 'react'
import NatFacilityReserveRepo from '../facilityReserve/repository/NatFacilityReserveRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {SortOrder} from '../../../components/shared/SortOrder'
import {
    BillingDataInfo,
    NatGetFacilityReserveBillingData,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetFacilityReserveBillingData'
import {
    NatPostFacilityReserveBillingData,
    NatPostFacilityReserveBillingDataParams,
} from './repository/NatPostFacilityReserveBillingData'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate'
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay'
import SortableTableHeader, {
    SortableTableHeaderCell,
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import {Messages} from '../../../Messages'
import {formatDateTimeForUpdateDate} from '../../../formatters/formatDate'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {
    CONFIRMATION_STATUS,
    MESSAGE_TYPE,
    MONTH,
    ROLE_FOR_ADMINISTRATOR,
    VALID_OR_NOT,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {HKConstants} from '../../../HKConstants'
import {judgeRoleCheck} from '../../common/util/Natutil'
import {NatPutBillingData, PutBillingDataParams} from './repository/NatPutBillingData'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {NatGetCondominium, UseFunctionInfo} from '../condominium/repository/NatGetCondominium'
import {DialogButtonParams} from '../../../components/shared/pageBaseComponents/DialogComponent'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_SEARCH_CONDITION: string = 'adminFacilityReserveBillingDataPageSearchCondition'
const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    facilityReserveRepo: NatFacilityReserveRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    billingDataInfo: BillingDataInfo[]
    searchResult: SearchResult
    isLoadCompleted: boolean
    minYear: string
    maxYear: string
    useYears: string
    useMonths: string
    confirmation: boolean
    expiredBillingDeadline: boolean
    useCasysLinked: boolean
}

// 機能
const FUNCTION_DIV_ID_CASYS_LINKED: number = 31

class NatAdminFacilityReserveBillingDataPage extends Component<Props & AdminPagePropsSet, States> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        // 前回検索条件が保持されていればデフォルト値として設定する
        let lastSearchCondition: SearchConditionPageInfo = {}
        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        }

        let defaultSearchConditionPage: SearchConditionPageInfo = {
            pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        if (lastSearchCondition.pageNum) {
            defaultSearchConditionPage = {
                pageNum: Number(lastSearchCondition.pageNum),
                page: COMMON_CONSTANTS.FIRST_PAGE,
            }
        }

        let confirmation: boolean = false
        if (this.props.location.state &&
            this.props.location.state.confirmation) {
            confirmation = true
            this.props.navigate(
                this.props.location.pathname,
                {
                    state: {
                        confirmation: false,
                    },
                },
            )
        }

        this.state = {
            searchConditionPageInfo: defaultSearchConditionPage,
            searchConditionSortInfo: [
                new SortOrder('outputDatetime', 'desc'),
            ],
            billingDataInfo: [],
            searchResult: {},
            isLoadCompleted: false,
            minYear: '',
            maxYear: '',
            useYears: '',
            useMonths: '',
            confirmation: confirmation,
            expiredBillingDeadline: true,
            useCasysLinked: false,
        }

        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.onClickBillingDataOutputButton = this.onClickBillingDataOutputButton.bind(this)
        this.onChangeUseMonths = this.onChangeUseMonths.bind(this)
        this.onChangeUseYears = this.onChangeUseYears.bind(this)
        this.confirmationButton = this.confirmationButton.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {

        await this.props.eventEmitter.showLoading()
        try {
            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                // 出力条件「利用年月」にて使用するstateを設定
                const currentDate = new Date(currentDateTime.details.currentDateTime)
                const currentYear = currentDate.getFullYear()
                const currentMonth = currentDate.getMonth()
                const lastDate = new Date(currentYear, (currentMonth - 1), 1)
                const lastMonthYear = lastDate.getFullYear()
                const lastMonth = lastDate.getMonth() + 1

                const minYear = HKConstants.VMN.FAC.MIN_SELECTABLE_YEAR
                const maxYear: string = String(currentDate.getFullYear())
                this.setState({
                    useYears: String(lastMonthYear),
                    useMonths: String(lastMonth),
                    minYear: minYear > lastMonthYear ? lastMonthYear : minYear,
                    maxYear: maxYear,
                })

                const condominiumCd = SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)
                if (condominiumCd) {
                    const condominiumInfo: Nullable<NatGetCondominium> = await this.props.asyncCallFunction(
                        this.props.condominiumRepo.getCondominium.bind(
                            this.props.condominiumRepo,
                            condominiumCd,
                        ),
                        (httpErrorOrNetworkError) => {
                            this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                        },
                    )
                    if (condominiumInfo && condominiumInfo.details) {
                        const useCasysLinkedInfo: UseFunctionInfo | undefined =
                            condominiumInfo.details.useFunctionInfo.find(
                                (useFunction) => useFunction.functionId === FUNCTION_DIV_ID_CASYS_LINKED)
                        let useCasysLinked: boolean = false
                        if (useCasysLinkedInfo !== undefined) {
                            useCasysLinked = useCasysLinkedInfo.validFlag === VALID_OR_NOT.VALID.value
                        }

                        this.setState({
                            expiredBillingDeadline:
                                currentDate.getDate() > Number(condominiumInfo.details.billingDeadline),
                            useCasysLinked: useCasysLinked,
                        })
                    }
                }
            }

            // 請求データ一覧取得
            await this.searchFacilityReserveBillingData(
                this.state.searchConditionPageInfo,
            )
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (this.state.confirmation) {
            this.setState({confirmation: false})
            const confirmationMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IFACA0038.toString(''),
            }
            this.props.eventEmitter.showHeadingAreaMessage(confirmationMessage)
            return
        }
    }

    onChangeUseYears(event: SelectChangeEvent<unknown>): void {
        this.setState({useYears: event.target.value as string})
    }

    onChangeUseMonths(event: SelectChangeEvent<unknown>): void {
        this.setState({useMonths: event.target.value as string})
    }

    getYearsList(): OptionProps[] {
        const years: OptionProps[] = []
        for (let selectYear: number = Number(this.state.minYear);
             selectYear <= Number(this.state.maxYear);
             selectYear++
        ) {
            years.push({
                label: String(selectYear),
                value: String(selectYear),
            })
        }
        return years
    }

    isOutputDisabled(): boolean {
        return !(this.state.useYears && this.state.useMonths)
    }

    async searchFacilityReserveBillingData(searchConditionPageInfo?: SearchConditionPageInfo,
                                           loadingFlag: boolean = true): Promise<void> {
        if (loadingFlag) {
            await this.props.eventEmitter.showLoading()
        }
        try {

            // 請求データ一覧取得
            const getFacilityReserveBillingDataResponse: Nullable<NatGetFacilityReserveBillingData> =
                await this.props.asyncCallFunction(
                    this.props.facilityReserveRepo.getFacilityReserveBillingData.bind(
                        this.props.facilityReserveRepo,
                        searchConditionPageInfo,
                    ),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )

            if (getFacilityReserveBillingDataResponse && getFacilityReserveBillingDataResponse.details) {

                this.setState({
                    billingDataInfo: getFacilityReserveBillingDataResponse.details.billingDataInfo,
                    searchResult: getFacilityReserveBillingDataResponse.details.searchResult,
                })

            }

        } finally {
            if (loadingFlag) {
                this.props.eventEmitter.closeLoading()
            }
        }
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: SearchConditionPageInfo = {
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.searchFacilityReserveBillingData(
            searchConditionPageInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.searchFacilityReserveBillingData(
            searchConditionPageInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    async confirmationButton(billingDataInfo: BillingDataInfo): Promise<void> {
        let errorLevel: MESSAGE_TYPE
        let message: string
        let buttonProps: DialogButtonParams[]

        if (this.state.expiredBillingDeadline) {
            errorLevel = Messages.WFACA0015.errorLevel
            message = Messages.WFACA0015.toString()
            buttonProps = [{
                isDefault: false,
                buttonLabel: '閉じる',
                buttonHandler: this.handleRegisterCancelClick,
            }]
        } else {
            errorLevel = Messages.IOPCC0021.errorLevel
            message = Messages.IOPCC0021.toString()
            buttonProps = [
                {
                    isDefault: false,
                    buttonLabel: 'キャンセル',
                    buttonHandler: this.handleRegisterCancelClick,
                },
                {
                    isDefault: false,
                    buttonLabel: 'OK',
                    buttonHandler: this.handleRegisterOkClick.bind(this, billingDataInfo),
                },
            ]
        }

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: errorLevel,
                message: message,
                buttonProps: buttonProps,
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(billingDataInfo: BillingDataInfo): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const request: PutBillingDataParams = {
                version: billingDataInfo.version,
            }
            const response: Nullable<NatPutBillingData> = await this.props.asyncCallFunction(
                this.props.facilityReserveRepo.putFacilityReserveBillingData.bind(
                    this.props.facilityReserveRepo,
                    billingDataInfo.billingDataId,
                    request,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    this.props.location.pathname,
                    {
                        state: {
                            confirmation: true,
                        },
                    },
                )
                window.location.reload()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }


    renderFacilityReserveBillingDataTable(billingDataInfos: BillingDataInfo[]): Nullable<ReactElement> {
        if (billingDataInfos.length === 0) {
            return null
        }
        const headers: SortableTableHeaderCell[] = [
            {id: 'fileName', label: '出力ファイル'},
            {id: 'outputDatetime', label: '出力日時'},
            {id: 'useYearsMonths', label: '利用年月'},
            {id: 'outputterName', label: '出力者'},
            {id: 'adminNameSettingStatus', label: '請求先設定済'},
        ]
        if (judgeRoleCheck([ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value]) && this.state.useCasysLinked) {
            headers.push({id: 'action', label: '操作'})
        }

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.searchResult.total ? this.state.searchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                />
                <SortablePaginationTableBody>
                    {billingDataInfos.map(
                        (billingDataInfo, index) => this.renderFacilityReserveBillingDataRecord(billingDataInfo, index),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }


    renderFacilityReserveBillingDataRecord(billingDataInfo: BillingDataInfo, index: number): ReactElement {

        // 出力ファイル欄は請求ファイルの有無で出力内容を変更
        let outputFile
        if (billingDataInfo.path !== null) {
            outputFile = <Link href={billingDataInfo.path} underline="hover">{billingDataInfo.fileName}</Link>
        } else {
            outputFile = '出力対象の請求データはありませんでした'
        }

        return (
            <TableRow key={`${billingDataInfo.fileName}_${index}`}>
                <TableCell align={'center'}>
                    {outputFile}
                </TableCell>
                <TableCell align={'center'}>
                    {formatDateTimeForUpdateDate(billingDataInfo.outputDatetime)}
                </TableCell>
                <TableCell align={'center'}>
                    {billingDataInfo.useYearsMonths.slice(0, 4)}-{billingDataInfo.useYearsMonths.slice(4, 6)}
                </TableCell>
                <TableCell align={'center'}>
                    {billingDataInfo.outputterFamilyName + '　' + billingDataInfo.outputterFirstName}
                </TableCell>
                <TableCell align={'center'}>
                    {(billingDataInfo.adminNameSettingStatus) ?
                        VALID_OR_NOT_CHECK.VALID.label : VALID_OR_NOT_CHECK.NOT.label}
                </TableCell>
                {judgeRoleCheck([ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value]) && this.state.useCasysLinked &&
                    <TableCell align={'center'}>
                        {this.renderAction(billingDataInfo)}
                    </TableCell>
                }
            </TableRow>
        )
    }

    renderAction(billingDataInfo: BillingDataInfo): ReactElement {
        if (billingDataInfo.confirmationStatus === CONFIRMATION_STATUS.CONFIRMED.value) {
            return (
                <AdminPrimaryButton disabled={true}>
                    連携済
                </AdminPrimaryButton>
            )
        }
        if (billingDataInfo.confirmedFlag === VALID_OR_NOT.VALID.value) {
            return (<ActionTxt>{'同利用年月\n請求連携済'}</ActionTxt>)
        }
        if (billingDataInfo.latestFlag === VALID_OR_NOT.NOT.value) {
            return (<ActionTxt>{'最新ファイル\nあり'}</ActionTxt>)
        }
        if (!billingDataInfo.adminNameSettingStatus) {
            return (
                <AdminPrimaryButton disabled={true}>
                    連携不可
                </AdminPrimaryButton>
            )
        }
        if (billingDataInfo.confirmationStatus === CONFIRMATION_STATUS.UNCONFIRMED.value) {
            return (
                <AdminPrimaryButton
                    onClick={() => this.confirmationButton(billingDataInfo)}
                >
                    連携
                </AdminPrimaryButton>
            )
        }
        return (<></>)
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.billingDataInfo.length === 0) {
            return {noResultMessage: Messages.IOPCC0015.toString('請求データ出力履歴')}
        }

        return {
            totalCount: this.state.searchResult.total ? this.state.searchResult.total : undefined,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    async onClickBillingDataOutputButton(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const postFacilityReserveBillingDataParams: NatPostFacilityReserveBillingDataParams = {
                useYears: this.state.useYears,
                useMonths: this.state.useMonths,
            }
            const postFacilityReserveBillingDataResponse:
                Nullable<NatPostFacilityReserveBillingData> =
                await this.props.asyncCallFunction(
                    this.props.facilityReserveRepo.postFacilityReserveBillingData.bind(
                        this.props.facilityReserveRepo, postFacilityReserveBillingDataParams,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                )
            if (postFacilityReserveBillingDataResponse &&
                postFacilityReserveBillingDataResponse.requestError === null) {
                // 請求データ一覧取得
                await this.searchFacilityReserveBillingData(
                    this.state.searchConditionPageInfo,
                    false,
                )
                const initialMessage: HeadingAreaMessageParams = {
                    title: null,
                    messageLevel: MESSAGE_TYPE.INFORMATION,
                    detail: Messages.IFACA0028.toString(
                        this.state.useYears,
                        this.state.useMonths,
                    ),
                }
                await this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                >

                    <ConditionTable>
                        <ConditionTableBody>
                            <ConditionTableRow>
                                <ConditionCategoryCell>出力条件</ConditionCategoryCell>
                                <ConditionInputCell>
                                    <TermFlexContainer>
                                        <YearWrapper>
                                            <TermTxt>利用年月</TermTxt>
                                            <PPSelect
                                                data={this.getYearsList()}
                                                onChange={this.onChangeUseYears}
                                                eventKeys={['useYears']}
                                                eventEmitter={this.props.eventEmitter}
                                                value={this.state.useYears}
                                            />
                                            <TermTxt>年</TermTxt>
                                        </YearWrapper>
                                        <MonthWrapper>
                                            <PPSelect
                                                data={MONTH.values()}
                                                onChange={this.onChangeUseMonths}
                                                eventKeys={['useMonths']}
                                                eventEmitter={this.props.eventEmitter}
                                                value={this.state.useMonths}
                                            />
                                            <TermTxt>月</TermTxt>
                                        </MonthWrapper>
                                    </TermFlexContainer>
                                </ConditionInputCell>
                                <ConditionButtonCell>
                                    <AdminDefaultMediumButton
                                        disabled={this.isOutputDisabled()}
                                        onClick={this.onClickBillingDataOutputButton}>
                                        請求データ出力
                                    </AdminDefaultMediumButton>
                                </ConditionButtonCell>
                            </ConditionTableRow>
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <PageMainArea>
                    {this.renderFacilityReserveBillingDataTable(this.state.billingDataInfo)}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminFacilityReserveBillingDataPage)

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const TermFlexContainer: StyledDiv = styled.div`
  display: flex;
  align-items: center;
`

const YearWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  max-width: 25%;
  align-items: end;
`

const MonthWrapper = styled(YearWrapper)`
  max-width: 15%;
  padding-left: 15px;
`

const ActionTxt: StyledSpan = styled.span`
  white-space: pre-wrap;
`
